export class ColorDictionary {
    public static readonly StatusRed = "#DC2626";       // tailwind red-600
    public static readonly StatusOrange = "#D97706";    // tailwind amber-600
    public static readonly StatusGreen = "#65A30D";     // tailwind lime-600
    public static readonly StatusGray = "#4B5563";      // tailwind gray-600
    public static readonly StatusBlue = "#0284C7";      // tailwind-sky-600
}